import { useContext } from "react";
import { AuthProvider as OidcAuthProvider } from "react-oidc-context";
import { AuthConsumer, AuthContext } from "./AuthConsumer";
import type { AuthProviderProps } from "./types";

export * from "./types";
export * from "./utils";

export const useAuth = () => useContext(AuthContext);

// Wrapper component that provides both OIDC and our custom auth context
export const AuthProvider = ({ children, cognitoAuthConfig }: AuthProviderProps) => {
  return (
    <OidcAuthProvider {...cognitoAuthConfig}>
      <AuthConsumer cognitoAuthConfig={cognitoAuthConfig}>{children}</AuthConsumer>
    </OidcAuthProvider>
  );
};
